import { render, staticRenderFns } from "./CertificationsIso.vue?vue&type=template&id=215dbec7&"
import script from "./CertificationsIso.vue?vue&type=script&lang=js&"
export * from "./CertificationsIso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports